import {
  BONE,
  BRAIN,
  CITRUS,
  CONVENIENCE,
  EYE,
  FOCUS,
  LEAF,
  ORBIT,
  SCALE,
  SHEILD_HALF,
  TESTTUBE_DIAGONAL,
  LIFESAVER,
  HEART_PULSE,
  BOLT,
} from '../components/ui/SvgIcons';

import {
  rfThinkFactor,
  antioxidantsBottle,
  fullSpectrumBottle,
  immuneFactorsBottle,
  nacBottle,
  berberineBottle,
  vitaminBComplexBottle,
  redYeastRiceBottle,
  vesselProtectionBottle,
  vitaminD3K22000Bottle,
  vitaminD3K25000Bottle,
  thinkHowItWrks,
  acbHowItWrks,
  fscHowItWrks,
  imfHowItWrks,
  nacHowItWrks,
  berHowItWrks,
  vbcHowItWrks,
  ryrHowItWrks,
  vepHowItWrks,
  dk2HowItWrks,
  dk5HowItWrks,
} from '../../src/images';

import { immuneFactor, testimonialsReliefImg } from '../../src/images';

export const mainBenefitsContent = {
  TNK: {
    label: 'Key Benefits & Why They Matter',
    heading: 'Treat your mind right, every day',
    benefits: [
      {
        icon: <FOCUS height={64} />,
        title: 'Sharper Focus & Memory',
        desc: 'Powered by 500 mg of Citicoline, shown in studies to support memory, attention, and overall cognitive performance.*',
      },
      {
        icon: <SHEILD_HALF height={64} />,
        title: 'Neuroprotection Against Aging',
        desc: 'Together, these nutrients combat oxidative stress and inflammation in the brain. This helps protect neurons and may slow age-related cognitive decline, preserving long-term brain health.*',
      },
      {
        icon: <ORBIT height={64} />,
        title: 'Synergistic Brain Support',
        desc: 'This unique combination of Citicoline, Lutein, and Zeaxanthin delivers comprehensive coverage for cognitive health, which can also benefit aspects of spatial reasoning and more.*',
      },
    ],
    gradientType: 'rel',
    image: thinkHowItWrks,
    ctaImage: rfThinkFactor,
    ctaText: 'Cognition Support',
    ctaSubText: 'Think Factor',
    buttonText: 'Shop Now',
  },
  ACB: {
    label: 'Key Benefits & Why They Matter',
    heading: 'Take charge of your well-being',
    benefits: [
      {
        icon: <SHEILD_HALF height={64} />,
        title: 'Protect Against Free Radicals',
        desc: 'Vitamin C combined with bioflavonoids fortifies your cells against stressors that may accelerate aging.',
      },
      {
        icon: <CITRUS height={64} />,
        title: 'Support Healthy Immune Function',
        desc: 'Vitamin C is widely recognized for its role in immune system support, especially when combined with potent botanicals.',
      },
      {
        icon: <ORBIT height={64} />,
        title: 'Promote Natural Vitality',
        desc: 'Ingredients like Quercetin, Rutin, Hesperidin, and Resveratrol work synergistically to keep you feeling energized and focused.',
      },
    ],
    gradientType: 'rel',
    image: acbHowItWrks,
    ctaImage: antioxidantsBottle,
    ctaText: 'Antioxidant Boosters',
    ctaSubText: 'Antioxidants with Vitamin C ',
    buttonText: 'Shop Now',
  },
  FSE: {
    label: 'Key Benefits & Why They Matter',
    heading: 'Treat your body right, every day',
    benefits: [
      {
        icon: <SHEILD_HALF height={64} />,
        title: 'Powerful Antioxidant Support',
        desc: 'Vitamin E (as d-alpha-tocopherol, Novatol™) plus selenium (as Glycinate, ALBION®) helps reinforce your body’s natural defense against free radicals—keeping you feeling and looking your best.',
      },
      {
        icon: <EYE height={64} />,
        title: 'Skin & Eye Health',
        desc: 'Vitamin A (as Retinol Acetate) plus natural carotenoids from Dunaliella salina and Aztec Marigold (standardized to 5% Zeaxanthin) are known allies for glowing skin and clear vision.',
      },
      {
        icon: <BRAIN height={64} />,
        title: 'Enhanced Vitality & Cognitive Support',
        desc: 'DMAE Bitartrate is traditionally used to support cognitive function and healthy mood, helping you stay sharp and energized.',
      },
    ],
    gradientType: 'rel',
    image: fscHowItWrks,
    ctaImage: fullSpectrumBottle,
    ctaText: 'Spectrum E Vitamins',
    ctaSubText: 'Full Spectrum E',
    buttonText: 'Shop Now',
  },
  IMF: {
    label: 'Key Benefits & Why They Matter',
    heading: 'Treat your body right, every day',
    benefits: [
      {
        icon: <SHEILD_HALF height={64} />,
        title: 'Comprehensive Immune Support',
        desc: 'Packed with Echinacea angustifolia, Andrographis, and Astragalus to help reinforce your body’s natural defenses.',
      },
      {
        icon: <ORBIT height={64} />,
        title: 'Enhanced Synergy',
        desc: 'Our combination of berberine (from Berberis Aristata) and Echinacea purpurea offers a unique blend not typically found in standard immune supplements.',
      },
      {
        icon: <TESTTUBE_DIAGONAL height={64} />,
        title: 'Confidence in Quality',
        desc: 'Each extract is standardized, so you know you’re getting consistent potency in every capsule.',
      },
    ],
    gradientType: 'rel',
    image: imfHowItWrks,
    ctaImage: immuneFactorsBottle,
    ctaText: 'Immune Support',
    ctaSubText: 'Immune Factors',
    buttonText: 'Shop Now',
  },
  NAC: {
    label: 'Key Benefits & Why They Matter',
    heading: 'Treat your body right, every day',
    benefits: [
      {
        icon: <BOLT height={64} />,
        title: 'Boosts Antioxidant Power',
        desc: 'NAC raises glutathione levels, while selenium supports key selenoproteins like glutathione peroxidase for powerful oxidative stress defense.',
      },
      {
        icon: <SHEILD_HALF height={64} />,
        title: 'Supports Immunity and Detox',
        desc: 'NAC modulates inflammation, selenium strengthens immune response, and molybdenum aids detox enzymes like sulfite oxidase.',
      },
      {
        icon: <ORBIT height={64} />,
        title: 'Nutrients That Work Better Together',
        desc: 'This trio synergizes to enhance absorption, glutathione production, and overall cellular protection more effectively than when taken alone.',
      },
    ],
    gradientType: 'rel',
    image: nacHowItWrks,
    ctaImage: nacBottle,
    ctaText: '',
    ctaSubText: 'NAC N-Acetyl L-Cysteine',
    buttonText: 'Shop Now',
  },
  BER: {
    label: 'Key Benefits & Why They Matter',
    heading: 'Support for blood sugar and metabolism',
    benefits: [
      {
        icon: <SCALE height={64} />,
        title: 'Healthy Blood Sugar Balance',
        desc: 'Berberine may support balanced glucose levels already within the normal range, helping you feel more energetic throughout the day',
      },
      {
        icon: <LIFESAVER height={64} />,
        title: 'Metabolic Support',
        desc: 'A well-supported metabolism can help maintain healthy weight management and energy production—giving you that extra boost.',
      },
      {
        icon: <HEART_PULSE height={64} />,
        title: 'Digestive and Cardiovascular Health',
        desc: 'Traditionally used to support digestive comfort, Berberine has also been studied for its supportive role in cardiovascular well-being.',
      },
    ],
    gradientType: 'rel',
    image: berHowItWrks,
    ctaImage: berberineBottle,
    ctaText: 'Blood Sugar Support',
    ctaSubText: 'Berberine',
    buttonText: 'Shop Now',
  },
  VBC: {
    label: 'Key Benefits & Why They Matter',
    heading: 'Treat your body right, every day',
    benefits: [
      {
        icon: <BOLT height={64} />,
        title: 'Boosts Energy Levels',
        desc: 'High-potency B vitamins (like B1, B2, B3, B6, and B12) help turn nutrients into usable energy, so you can stay alert without relying on caffeine or sugar.',
      },
      {
        icon: <SHEILD_HALF height={64} />,
        title: 'Supports Healthy Stress Response',
        desc: 'Folate, Vitamin B6, and Vitamin C can help your body better cope with everyday stress and maintain a balanced mood.',
      },
      {
        icon: <LEAF height={64} />,
        title: 'Promotes Overall Wellness',
        desc: 'From supporting brain function to fostering healthy skin, hair, and nails, B vitamins have wide-ranging benefits for your daily vitality.',
      },
    ],
    gradientType: 'rel',
    image: vbcHowItWrks,
    ctaImage: vitaminBComplexBottle,
    ctaText: 'Supercharged B Vitamins',
    ctaSubText: 'Vitamin B Complex',
    buttonText: 'Shop Now',
  },
  RYR: {
    label: 'Key Benefits & Why They Matter',
    heading: 'Treat your body right, every day',
    benefits: [
      {
        icon: <HEART_PULSE height={64} />,
        title: 'Supports Healthy Cholesterol Levels',
        desc: 'Red Yeast Rice can naturally help reduce LDL (“bad”) cholesterol and support overall heart health.',
      },
      {
        icon: <SHEILD_HALF height={64} />,
        title: 'Protects Heart and Muscle Energy',
        desc: 'CoQ10 is essential for energy production in cells, especially in the heart and muscles.',
      },
      {
        icon: <ORBIT height={64} />,
        title: 'Cellular Support',
        desc: 'These ingredients act as a powerful antioxidant, protecting cells from damage and promoting healthy aging and cardiovascular function.',
      },
    ],
    gradientType: 'rel',
    image: ryrHowItWrks,
    ctaImage: redYeastRiceBottle,
    ctaText: 'Heart Health',
    ctaSubText: 'Red Yeast Rice with CoQ10',
    buttonText: 'Shop Now',
  },
  VEP: {
    label: 'Key Benefits & Why They Matter',
    heading: 'Treat your heart right, every day',
    benefits: [
      {
        icon: <FOCUS height={64} />,
        title: 'Cardiovascular Focus',
        desc: 'Designed to help keep blood vessels healthy and maintain normal homocysteine levels. Ideal for those taking a proactive approach to heart health.',
      },
      {
        icon: <LEAF height={64} />,
        title: 'Bioactive Nutrient Forms',
        desc: 'Many generic products use synthetic forms of folic acid or B12, but Vessel Protection uses L-5-MTHF (Magnofolate® C) and Methylcobalamin for optimal absorption—perfect for individuals seeking the cleanest, most effective forms.',
      },
      {
        icon: <CONVENIENCE height={64} />,
        title: 'Convenience & Simplicity',
        desc: 'Just one capsule a day makes it easy to stay consistent. No juggling multiple pills and no concerns about synthetic fillers—only rice flour and a gelatin capsule shell.',
      },
    ],
    gradientType: 'rel',
    image: vepHowItWrks,
    ctaImage: vesselProtectionBottle,
    ctaText: 'Vessel Protection Essentials',
    ctaSubText: 'Vessel Protection',
    buttonText: 'Shop Now',
  },
  DK2: {
    label: 'Key Benefits & Why They Matter',
    heading: 'Support your bones and heart, every day',
    benefits: [
      {
        icon: <BONE height={64} />,
        title: 'Bone & Joint Fortification',
        desc: 'The D3–K2 combination is specifically designed to keep your bones strong, so you can stay active as you age.',
      },
      {
        icon: <HEART_PULSE height={64} />,
        title: 'Heart & Artery Health',
        desc: 'K2 helps ensure calcium doesn’t settle in your blood vessels, supporting long-term cardiovascular wellness.',
      },
      {
        icon: <SHEILD_HALF height={64} />,
        title: 'Immune System Boost',
        desc: 'Vitamin D3 plays a notable role in maintaining a healthy immune system, especially during times when you’re not exposed to enough sunlight.',
      },
    ],
    gradientType: 'rel',
    image: dk2HowItWrks,
    ctaImage: vitaminD3K22000Bottle,
    ctaText: 'Bone & Heart Health',
    ctaSubText: 'Vitamin D3 and K-2 2000 IU',
    buttonText: 'Shop Now',
  },
  DK5: {
    label: 'Key Benefits & Why They Matter',
    heading: 'TSupport your bones and heart, every day',
    benefits: [
      {
        icon: <BONE height={64} />,
        title: 'Comprehensive Immune Support',
        desc: 'Packed with Echinacea angustifolia, Andrographis, and Astragalus to help reinforce your body’s natural defenses.',
      },
      {
        icon: <HEART_PULSE height={64} />,
        title: 'Enhanced Synergy',
        desc: 'Our combination of berberine and Echinacea purpurea offers a unique blend not typically found in standard immune supplements.',
      },
      {
        icon: <SHEILD_HALF height={64} />,
        title: 'Confidence in Quality',
        desc: 'Each extract is standardized, so you know you’re getting consistent potency in every capsule.',
      },
    ],
    gradientType: 'rel',
    image: dk5HowItWrks,
    ctaImage: vitaminD3K25000Bottle,
    ctaText: 'Bone & Heart Health',
    ctaSubText: 'Vitamin D3 and K-2 5000 IU',
    buttonText: 'Shop Now',
  },
};
